<template lang="pug">
  .block
    .content
      slot
</template>

<style lang="stylus" scoped>
.block
  display inline-grid
  width 100%
.content
  // position 
  width 80%
  max-width 72rem
  justify-self center
  // layout
  display inline-grid
</style>

<script>
export default {
  name: "block"
};
</script>
